export const DEFAULT_LANGUAGE: string = 'en-GB';
